export enum UsageLimitState {
  ALLOWED = 'ALLOWED',

  REJECTED = 'REJECTED',

  UNDEFINED = 'UNDEFINED',

  FORBIDDEN = 'FORBIDDEN'
}